export default {"src":"/_next/static/media/fireblocks.64d070a3.svg","height":68,"width":272,"blurWidth":0,"blurHeight":0};